import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { httpinstance,httpinstancefile } from "../../../axios/api"


export const get_payment_request_list = createAsyncThunk('get_payment_request_list', async (queryParams)=>{
    try{
        const url = `admin/list_offline_payment${queryParams}`
        const response = await httpinstance.get(url)
        return response
    }catch (err){
        return err.response
    }
})

export const get_repayment_request_list = createAsyncThunk('get_repayment_request_list', async (queryParams)=>{
    try{
        const url = `admin/list_repayment_data${queryParams}`
        const response = await httpinstance.get(url)
        return response
    }catch (err){
        return err.response
    }
})

export const handle_payment_request = createAsyncThunk('handle_payment_request', async (values)=>{
    try{
        const url = 'admin/offline_payment_status_update'
        const response = await httpinstance.post(url,values)
        return response
    }catch (err){
        return err.response
    }
})

export const handle_repayment_request = createAsyncThunk('handle_repayment_request', async (values)=>{
    try{
        const url = 'admin/offline_repaymnet_status_update'
        const response = await httpinstance.post(url,values)
        return response
    }catch (err){
        return err.response
    }
})



const initialState = {
    data:{},
    loading:false,
}

const paymentRequestlice = createSlice({
    name : 'paymentRequest',
    initialState,
})
export default paymentRequestlice.reducer